/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Drive_List_ErrorInputs */

const es_tools_drive_list_error = /** @type {(inputs: Tools_Drive_List_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al listar Drive`)
};

const en_tools_drive_list_error = /** @type {(inputs: Tools_Drive_List_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error listing Drive`)
};

/**
* | output |
* | --- |
* | "Error listing Drive" |
*
* @param {Tools_Drive_List_ErrorInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_drive_list_error = /** @type {((inputs?: Tools_Drive_List_ErrorInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Drive_List_ErrorInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_drive_list_error(inputs)
	return en_tools_drive_list_error(inputs)
});
export { tools_drive_list_error as "tools.drive.list_error" }